const Header = ({ darkMode, setDarkMode }) => {
  return (
    <header className="fixed top-0 w-full flex items-center justify-between px-6 py-4 backdrop-blur-xs z-10">
      {darkMode ? (
        <img
          src={`${process.env.PUBLIC_URL}/payarcLogo.png`}
          alt="Logo"
          className="h-10 w-auto object-contain"
        />
      ) : (
        <img
          src={`${process.env.PUBLIC_URL}/payarcDarkLogo.png`}
          alt="Logo"
          className="h-10 w-auto object-contain"
        />
      )}
      <button
        onClick={() => setDarkMode(!darkMode)}
        className={`px-4 py-2 rounded-md border transition-all duration-200  ${
          !darkMode ? "text-slate-800 border-slate-800" : "text-white"
        }`}
      >
        {darkMode ? "Light Mode" : "Dark Mode"}
      </button>
    </header>
  );
};

export default Header;
